import XLSX from "xlsx";
import Axios from "axios";
import { ADMINISTRACION_USUARIOS } from "../../constants/urls";
import { auth } from "./firebase";

/**
 * Método encargado de exportar los datos en formato Excel.
 * @param {*} cols Columnas de los datos a exportar.
 * @param {*} data Datos a exportar.
 * @param {*} tabName Nombre de la pestaña.
 * @param {*} fileName Nombre del archivo.
 */
export function MaterialTableToExcel(cols, data, tabName = "datos", fileName = "datos") {
	const wb = XLSX.utils.book_new();
	data.unshift(cols);
	let ws = XLSX.utils.aoa_to_sheet(data);
	for (const key of Object.keys(ws)) {
		if (String(ws[key].v).includes("https://")) {
			ws[key].l = {
				Target: ws[key].v,
				Tooltip: "Curriculum",
			};
		}
	}
	XLSX.utils.book_append_sheet(wb, ws, tabName);
	XLSX.writeFile(wb, `${fileName}.xlsx`);
}

/**
 * Método encargado de exportar los datos en formato Spreadsheet.
 * @param {*} cols Columnas de los datos a exportar.
 * @param {*} data Datos a exportar.
 * @param {*} tabName Nombre de la pestaña.
 * @param {*} fileName Nombre del archivo.
 */
export async function MaterialTableToSpreadsheet(cols, data, tabName = "datos", fileName = "datos") {
	try {
		data.unshift(Array.from(cols).map(c => c.title));
		let postData = {
			data: data,
			tab_name: tabName,
			file_name: fileName,
			owner: auth.currentUser.email,
		}
		let url = `${ADMINISTRACION_USUARIOS}/export-data`;
		let response = await Axios.post(url, postData);
		return response.data;
	} catch (error) {
		console.error(error);
		throw error;
	}
}

/**
 * Método encargado de exportar un JSON a Excel.
 * @param {*} data Datos del JSON.
 * @param {*} tabName Nombre de la pestaña.
 * @param {*} fileName Nombre del archivo.
 */
export function JsonToExcel(data, tabName = "datos", fileName = "datos") {
	const wb = XLSX.utils.book_new();
	let values = Array.from(data).map(d => Object.values(d));
	values.unshift(Object.keys(data[0]));
	let ws = XLSX.utils.aoa_to_sheet(values);
	for (const key of Object.keys(ws)) {
		if (String(ws[key].v).includes("https://")) {
			ws[key].l = {
				Target: ws[key].v,
				Tooltip: "Curriculum",
			};
		}
	}
	XLSX.utils.book_append_sheet(wb, ws, tabName);
	XLSX.writeFile(wb, `${fileName}.xlsx`);
}